<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="模板"
      edit-title
      id-key="TemplateId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
    
    <!--
    <el-form-item label="类别编号" prop="ClassNo">
          <span v-if="Mode==0" class="detail-span">{{data.ClassNo}}</span>
          <el-input v-else v-model="data.ClassNo" placeholder="请输入类别编号"></el-input>
        </el-form-item>
      -->

      <template slot="form">
        <el-row>
          <!--
          <el-col :span="12">
            <el-form-item label="序号">
              <el-input
                type="number"
                v-int
                v-model="data.SerialNumber"
                style="width: 100px"
              ></el-input>
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
          -->
          <el-col :span="12">
            <el-form-item label="模板编号" prop="ClassNo">
              <el-input v-model="data.TemplateNo" placeholder="请输入类别编号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="模板名称" prop="ClassNo">
              <el-input v-model="data.TemplateName" placeholder="请输入模板名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加工阶段" prop="ProcessStage">
              <el-select v-model="data.Stage" clearable>
                <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select v-model="data.Status" >
                <el-option label="停用" :value="0" key="a1"></el-option>
                <el-option label="在用" :value="1" key="a2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import invoiceSelect from "@/components/basedata/basedoc/billtype/select";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    invoiceSelect,
  },
  data() {
    return {
      data: {
        TemplateId: null,
        TemplateNo: null,
        Stage: null,
        TemplateName: null,
        Status: 1,

        //AbstractId: 0,
        //SourceTypeId: null,
        //Abstract: "",
        //SerialNumber: null,
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/production/teTemplate").default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      // trendData: iForm.Data,
      showList: [],
      machiningStageList: [],
      rules: {
        TemplateNo: [{ required: true, message: "请输入编号" }],
        TemplateName: [{ required: true, message: "请输入名称" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });

      this.machiningStageApi.list({ Status: 1 }).then((res) => {
        this.machiningStageList = res.Data;
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(data) {
      // this.api.getMaxSn().then((res) => {
      //   this.data.SerialNumber = res;
      // });
    },
    onEditOpened(data) {},
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
